import React from 'react';

import { Text } from '@change/ds-core-ui';

import { TranslatePlural } from '@change-corgi/core-react/i18n';

import { useTotalResultsText } from './hooks/useTotalResultsText';

export const TotalResultsText: React.FC<EmptyProps> = () => {
	const {
		data: { count, countLocalized },
	} = useTotalResultsText();

	return (
		<Text as="h1" variant="body" size="small">
			<TranslatePlural
				value="corgi.search.header.mobile_subtitle"
				replacements={{
					countLocalized,
				}}
				count={count}
			/>
		</Text>
	);
};
